import styled from 'styled-components'

export const FieldsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  flex: 1;
  max-width: 100%;
  gap: 16px;

  & > div {
    flex: 1;
  }
`

export const ListWrapper = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;

  & > div:first-child {
    margin-right: 16px;
  }

  svg {
    margin-left: 0 !important;
  }
`

export const Title = styled.div`
  margin-top: 16px;
`
